module.exports = __webpack_public_path__ + "static/media/bil-loader.f2493f9d.gif";